export { applyMask } from './applyMask';
export { cleanMask } from './cleanMask';
export { deduplicatePastedPhone } from './deduplicatePastedPhone';
export { getPhoneErrorMessage } from './getPhoneErrorMessage';
export {
  getPhoneDigits,
  isRussianLocalPhoneNumber,
  normalizeRussianLocalPhoneInput,
  normalizeRussianLocalPhoneNumber,
} from './normalizeRussianLocalPhoneNumber';
export {
  normalizePhoneSearchTerm,
  normalizeRussianLocalPhoneSearchTerm,
} from './normalizePhoneSearchTerm';
export { phoneValidateHandler } from './phoneValidateHandler';
